import React, { useState } from "react";

function Faq() {
  const [tabMenu, tabActive] = useState({ a: true });
  const [generalLeftOpen, setGeneralLeftOpen] = useState(null);
  const [generalRightOpen, setGeneralRightOpen] = useState(null);
  const [pricingLeftOpen, setPricingLeftOpen] = useState(null);
  const [pricingRightOpen, setPricingRightOpen] = useState(null);
  const [accountLeftOpen, setAccountLeftOpen] = useState(null);
  const [accountRightOpen, setAccountRightOpen] = useState(null);
  const [returnsLeftOpen, setReturnsLeftOpen] = useState(null);
  const [returnsRightOpen, setReturnsRightOpen] = useState(null);
  const [supportLeftOpen, setSupportLeftOpen] = useState(null);
  const [supportRightOpen, setSupportRightOpen] = useState(null);


  // Général (2 colonnes, 3 questions chacune)
  const generalData = [
    {
      id: "collapseOne",
      question: "Comment Neoori peut-il m’aider ?",
      answer:
        "Neoori analyse votre profil, vos intérêts et vos compétences pour vous proposer un parcours personnalisé, adapté à votre évolution personnelle ou professionnelle.",
    },
    {
      id: "collapseTwo",
      question: "Neoori est-il adapté aux jeunes (Gen Z) ?",
      answer:
        "Oui. L’application est pensée pour offrir une expérience moderne, rapide et interactive destinée aux 15–30 ans.",
    },
    {
      id: "collapseThree",
      question: "Ai-je besoin de connaissances particulières ?",
      answer:
        "Pas du tout. Neoori vous accompagne étape par étape, même si vous ne savez pas par où commencer.",
    },
    {
      id: "collapseFour",
      question: "Puis-je utiliser Neoori gratuitement ?",
      answer:
        "Oui, une version gratuite permet de découvrir l’application et de réaliser vos premiers tests.",
    },
    {
      id: "collapseFive",
      question: "Mes données sont-elles sécurisées ?",
      answer:
        "Oui. Neoori respecte strictement les réglementations RGPD et ne partage jamais vos informations.",
    },
    {
      id: "collapseSix",
      question: "Puis-je changer mon parcours par la suite ?",
      answer:
        "Oui, toutes vos recommandations s’adaptent automatiquement dès que vous mettez à jour votre profil.",
    },
  ];

  // Tarification
  const pricingData = [
    {
      id: "pricingOne",
      question: "Y a-t-il des frais cachés ?",
      answer:
        "Non. La tarification est transparente et affichée clairement selon votre formule.",
    },
    {
      id: "pricingTwo",
      question: "Comment passer à la version Premium ?",
      answer:
        "Vous pouvez activer la version Premium directement depuis l’application en un clic.",
    },
    {
      id: "pricingThree",
      question: "Puis-je annuler mon abonnement ?",
      answer: "Oui, vous pouvez annuler à tout moment sans engagement.",
    },
    {
      id: "pricingFour",
      question: "Quelle est la différence entre Gratuit et Premium ?",
      answer:
        "Le Premium débloque des analyses détaillées, des tests avancés, des recommandations illimitées et un accès prioritaire au support.",
    },
    {
      id: "pricingFive",
      question: "Y a-t-il une réduction pour étudiants ?",
      answer: "Oui, une réduction spéciale est proposée lors de l’inscription.",
    },
    {
      id: "pricingSix",
      question: "Puis-je changer de formule à tout moment ?",
      answer:
        "Oui, l’upgrade comme le downgrade sont possibles quand vous le souhaitez.",
    },
  ];

  // Compte
  const accountData = [
    {
      id: "accountOne",
      question: "Comment créer un compte ?",
      answer:
        "Téléchargez l’application, inscrivez-vous avec votre email ou votre numéro, et commencez en quelques minutes.",
    },
    {
      id: "accountTwo",
      question: "J’ai oublié mon mot de passe, que faire ?",
      answer:
        "Utilisez « Mot de passe oublié » et suivez les instructions pour réinitialiser.",
    },
    {
      id: "accountThree",
      question: "Puis-je connecter mon compte Google/Apple ?",
      answer: "Oui, l’authentification rapide est disponible.",
    },
    {
      id: "accountFour",
      question: "Puis-je supprimer mon compte ?",
      answer:
        "Oui. Une option de suppression définitive est disponible dans Paramètres → Confidentialité.",
    },
    {
      id: "accountFive",
      question: "Puis-je utiliser Neoori sur plusieurs appareils ?",
      answer: "Oui. Votre compte synchronise vos données automatiquement.",
    },
    {
      id: "accountSix",
      question: "Comment modifier mes informations personnelles ?",
      answer: "Rendez-vous dans Paramètres → Profil.",
    },
  ];

  // Politique de remboursement
  const returnsData = [
    {
      id: "returnsOne",
      question: "Comment demander un remboursement ?",
      answer: "Contactez le support dans les 14 jours suivant votre achat.",
    },
    {
      id: "returnsTwo",
      question: "Quels achats sont remboursables ?",
      answer: "Les abonnements Premium payés en une fois et non consommés.",
    },
    {
      id: "returnsThree",
      question: "Combien de temps dure le traitement ?",
      answer: "Entre 5 et 10 jours ouvrés selon votre banque.",
    },
    {
      id: "returnsFour",
      question: "Puis-je être remboursé si j’annule après un mois ?",
      answer: "Non, seuls les achats récents peuvent être remboursés.",
    },
    {
      id: "returnsFive",
      question: "Comment contacter le support ?",
      answer: "Via l’application ou sur support@neoori.com.",
    },
    {
      id: "returnsSix",
      question: "Puis-je tester avant de payer ?",
      answer: "Oui, une version gratuite est disponible.",
    },
  ];

  // Support technique
  const supportData = [
    {
      id: "supportOne",
      question: "Neoori fonctionne-t-il sur tous les téléphones ?",
      answer: "Oui, sur Android et iOS.",
    },
    {
      id: "supportTwo",
      question: "L’application est lente, que faire ?",
      answer:
        "Essayez de redémarrer l’application ou de vérifier votre connexion internet.",
    },
    {
      id: "supportThree",
      question: "Je ne reçois pas mes notifications ?",
      answer:
        "Vérifiez vos permissions dans les paramètres de votre téléphone.",
    },
    {
      id: "supportFour",
      question: "Puis-je contacter un conseiller ?",
      answer: "Oui, un support humain est disponible pour les abonnés Premium.",
    },
    {
      id: "supportFive",
      question: "Comment signaler un problème ?",
      answer: "Depuis « Aide & Support » dans l’application.",
    },
    {
      id: "supportSix",
      question: "L’application ne s’installe pas ?",
      answer:
        "Assurez-vous d’avoir assez d’espace libre et la dernière version de votre système d’exploitation.",
    },
  ];

  return (
    <>
      <section id="faq" className="row_am faq_section">
        <div className="container">
          <div
            className="section_title"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <span className="title_badge">Questions &amp; Réponses</span>
            <h2>
              <span>FAQ</span> – Foire aux questions
            </h2>
          </div>

          <ul
            className="nav nav-tabs"
            id="myTab"
            role="tablist"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${tabMenu.a && "active"}`}
                onClick={() => tabActive({ a: true })}
                id="genral-tab"
                data-toggle="tab"
                data-target="#genral"
                type="button"
                role="tab"
                aria-controls="genral"
                aria-selected="true"
              >
                Général
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${tabMenu.b && "active"}`}
                onClick={() => tabActive({ b: true })}
                id="pricing-tab"
                data-toggle="tab"
                data-target="#pricing"
                type="button"
                role="tab"
                aria-controls="pricing"
                aria-selected="false"
              >
                Tarification
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${tabMenu.c && "active"}`}
                onClick={() => tabActive({ c: true })}
                id="account-tab"
                data-toggle="tab"
                data-target="#account"
                type="button"
                role="tab"
                aria-controls="account"
                aria-selected="false"
              >
                Compte
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${tabMenu.d && "active"}`}
                onClick={() => tabActive({ d: true })}
                id="returns-tab"
                data-toggle="tab"
                data-target="#returns"
                type="button"
                role="tab"
                aria-controls="returns"
                aria-selected="false"
              >
                Politique de remboursement
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${tabMenu.e && "active"}`}
                onClick={() => tabActive({ e: true })}
                id="support-tab"
                data-toggle="tab"
                data-target="#support"
                type="button"
                role="tab"
                aria-controls="support"
                aria-selected="false"
              >
                Support technique
              </button>
            </li>
          </ul>
          <div
            className="tab-content"
            id="myTabContent"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <div
              className={`tab-pane fade ${tabMenu.a && "show active"}`}
              id="genral"
              role="tabpanel"
              aria-labelledby="genral-tab"
            >
              <div className="accordion" id="generalAccordion">
                <div className="row">
                  <div className="col-md-6">
                    <div className="accordion" id="generalLeft">
                      {generalData.slice(0, 3).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  generalLeftOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() =>
                                  setGeneralLeftOpen(
                                    generalLeftOpen === faq.id ? null : faq.id
                                  )
                                }
                                aria-expanded={
                                  generalLeftOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      generalLeftOpen === faq.id
                                        ? "minus"
                                        : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              generalLeftOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#generalLeft"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="accordion" id="generalRight">
                      {generalData.slice(3, 6).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  generalRightOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() =>
                                  setGeneralRightOpen(
                                    generalRightOpen === faq.id ? null : faq.id
                                  )
                                }
                                aria-expanded={
                                  generalRightOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      generalRightOpen === faq.id ? "minus" : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              generalRightOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#generalRight"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-pane fade ${tabMenu.b && "show active"}`}
              id="pricing"
              role="tabpanel"
              aria-labelledby="pricing-tab"
            >
              <div className="accordion" id="pricingAccordion">
                <div className="row">
                  <div className="col-md-6">
                    <div className="accordion" id="pricingLeft">
                      {pricingData.slice(0, 3).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  pricingLeftOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() =>
                                  setPricingLeftOpen(
                                    pricingLeftOpen === faq.id ? null : faq.id
                                  )
                                }
                                aria-expanded={
                                  pricingLeftOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      pricingLeftOpen === faq.id ? "minus" : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              pricingLeftOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#pricingLeft"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="accordion" id="pricingRight">
                      {pricingData.slice(3, 6).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  pricingRightOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() =>
                                  setPricingRightOpen(
                                    pricingRightOpen === faq.id ? null : faq.id
                                  )
                                }
                                aria-expanded={
                                  pricingRightOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      pricingRightOpen === faq.id ? "minus" : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              pricingRightOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#pricingRight"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-pane fade ${tabMenu.c && "show active"}`}
              id="account"
              role="tabpanel"
              aria-labelledby="account-tab"
            >
              <div className="accordion" id="accountAccordion">
                <div className="row">
                  <div className="col-md-6">
                    <div className="accordion" id="accountLeft">
                      {accountData.slice(0, 3).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  accountLeftOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() =>
                                  setAccountLeftOpen(
                                    accountLeftOpen === faq.id ? null : faq.id
                                  )
                                }
                                aria-expanded={
                                  accountLeftOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      accountLeftOpen === faq.id ? "minus" : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              accountLeftOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#accountLeft"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="accordion" id="accountRight">
                      {accountData.slice(3, 6).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  accountRightOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() =>
                                  setAccountRightOpen(
                                    accountRightOpen === faq.id ? null : faq.id
                                  )
                                }
                                aria-expanded={
                                  accountRightOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      accountRightOpen === faq.id ? "minus" : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              accountRightOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#accountRight"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-pane fade ${tabMenu.d && "show active"}`}
              id="returns"
              role="tabpanel"
              aria-labelledby="returns-tab"
            >
              <div className="accordion" id="returnsAccordion">
                <div className="row">
                  <div className="col-md-6">
                    <div className="accordion" id="returnsLeft">
                      {returnsData.slice(0, 3).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  returnsLeftOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() =>
                                  setReturnsLeftOpen(
                                    returnsLeftOpen === faq.id ? null : faq.id
                                  )
                                }
                                aria-expanded={
                                  returnsLeftOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      returnsLeftOpen === faq.id ? "minus" : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              returnsLeftOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#returnsLeft"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="accordion" id="returnsRight">
                      {returnsData.slice(3, 6).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  returnsRightOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() =>
                                  setReturnsRightOpen(
                                    returnsRightOpen === faq.id ? null : faq.id
                                  )
                                }
                                aria-expanded={
                                  returnsRightOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      returnsRightOpen === faq.id ? "minus" : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              returnsRightOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#returnsRight"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-pane fade ${tabMenu.e && "show active"}`}
              id="support"
              role="tabpanel"
              aria-labelledby="support-tab"
            >
              <div className="accordion" id="supportAccordion">
                <div className="row">
                  <div className="col-md-6">
                    <div className="accordion" id="supportLeft">
                      {supportData.slice(0, 3).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  supportLeftOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() =>
                                  setSupportLeftOpen(
                                    supportLeftOpen === faq.id ? null : faq.id
                                  )
                                }
                                aria-expanded={
                                  supportLeftOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      supportLeftOpen === faq.id ? "minus" : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              supportLeftOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#supportLeft"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="accordion" id="supportRight">
                      {supportData.slice(3, 6).map((faq) => (
                        <div className="card" key={faq.id}>
                          <div className="card-header" id={`heading${faq.id}`}>
                            <h2 className="mb-0">
                              <button
                                className={`btn btn-link btn-block text-left ${
                                  supportRightOpen === faq.id ? "" : "collapsed"
                                }`}
                                type="button"
                                onClick={() => setSupportRightOpen(supportRightOpen === faq.id ? null : faq.id)}
                                aria-expanded={
                                  supportRightOpen === faq.id ? "true" : "false"
                                }
                                aria-controls={`collapse${faq.id}`}
                              >
                                {faq.question}
                                <span className="icons">
                                  <i
                                    className={`icofont-${
                                      supportRightOpen === faq.id ? "minus" : "plus"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={`collapse${faq.id}`}
                            className={`collapse ${
                              supportRightOpen === faq.id ? "show" : ""
                            }`}
                            aria-labelledby={`heading${faq.id}`}
                            data-parent="#supportRight"
                          >
                            <div className="card-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;
